import React, { useState, useEffect } from 'react';
import axios from 'axios';

const axiosClient = axios.create({
	withCredentials: true,
});

const useMyOrganization = (preloadedData) => {

	const [myOrganization, setMyOrganization] = useState(preloadedData);
	const [error, setError] = useState(null);

	useEffect(() => {

		if (!myOrganization) {

			axiosClient.get('/api/v2/myorganization').then((response) => {

				if (response?.data) {
					setMyOrganization(response.data);
				}

			}).catch((err) => {

				console.error(err);
				setError(err);

			});

		}

	}, [myOrganization]);

	return {
		myOrganization,
		setMyOrganization,
		error,
		setError,
	};

};

export default useMyOrganization;
